import React, { useState } from "react";
import axios from "axios";
import CurrentLocation from "../../assets/icons8-location-50.png";

const LocationFetcher = ({ onChange, setLocation }) => {
  const fetchLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(getCityName, handleError);
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const getCityName = async (position) => {
    const { latitude, longitude } = position.coords;
    setLocation({ latitude, longitude });

    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyCmYRzM9CMuVD0C0xkQP6Vt9VyVcfMKQ2o`
      );
      //console.logresponse, 'response---')
      const addressComponents = response?.data?.results[0]?.address_components;
      const cityComponent = addressComponents.find((component) =>
        component.types.includes("locality")
      );
      const city = cityComponent ? cityComponent.long_name : "City not found";

      onChange({ value: city, label: city });
    } catch (error) {
      alert("Error fetching city name");
    }
  };

  const handleError = (error) => {
    console.error("Error fetching location:", error);
    if (error.code === error.PERMISSION_DENIED) {
      alert("Permission to access location was denied. Please allow location access in your browser settings.");
    } else if (error.code === error.POSITION_UNAVAILABLE) {
      alert("Location information is unavailable.");
    } else if (error.code === error.TIMEOUT) {
      alert("The request to get your location timed out.");
    } else {
      alert("An unknown error occurred.");
    }
  };

  return (
    <>
      <button
        onClick={fetchLocation}
        type="button"
        className="rounded dark location-btn"
      >
        <span className="search-icon">
          <img src={CurrentLocation} alt="Current Location Icon" className="icon" />
        </span>
        <span className="search-text">
          <img src={CurrentLocation} alt="Current Location Icon" className="icon" height={30} width={30} />
        </span>
      </button>
    </>
  );
};

export default LocationFetcher;
